import { useAuthStore } from '@/stores/login'
import { useUsersStore } from '@/stores/users'
import router from '@/router'
import { updateUserInfo } from '@/utils/userInfo'
import { getQueryString } from '@/utils'
import dsBridge from 'dsbridge'
import { showToast } from 'vant'
import i18n from '@/locales'

// 在文件的顶部添加以下代码来扩展 Window 接口
declare global {
  interface Window {
    jtJsBridge?: {
      jtH5CallNativeApi: (request: any, callback: (responseData: any) => void) => void
    }
  }
}

// 调用外场方法（使用 dsBridge）
const callNative = async (request: { method: string; data?: any }): Promise<any> => {
  return new Promise((resolve) => {
    dsBridge.call('jtH5CallNativeApi', request, (responseData) => {
      try {
        // 司机端约定返回 JSON 字符串，按需解析
        console.log(`output->responseData`, responseData)
        const parsed = typeof responseData === 'string' ? JSON.parse(responseData) : responseData
        resolve(parsed)
      } catch {
        // 如果不是合法 JSON，直接返回原值，避免异常中断
        resolve(responseData)
      }
    })
  })
}

/**
 * 注册 Native 调用 H5 的方法 ：app 调用H5
 * @param handler
 */
export function registerNative(handler: object | (() => any)) {
  // jtNativeCallH5Api 与原生协商固定
  dsBridge.register('jtNativeCallH5Api', handler)
}

export const isCnDriverAppSource = (): boolean => {
  const source = getQueryString('source') === 'cn_driver_app' || window.navigator.userAgent.indexOf('cn_driver_app') > -1
  return source
}

export const cnDriverAutoLogin = async (): Promise<boolean> => {
  if (!isCnDriverAppSource()) {
    return false
  }

  await joinSandsTalkDriver()
  const rawToken = getQueryString('token') || ''
  const tenantId = getQueryString('tenantId') || '1000'
  const collegeId = getQueryString('collegeId') || ''
  const sourceType = getQueryString('sourceType') || ''
  const jumpModuleId = getQueryString('jumpModuleId') || '' // 考试id
  // 免登成功前，先持久化司机环境标记，避免后续路由丢失 query
  localStorage.setItem('isCnDriverAppSource', 'cnDriverApp')

  // token 为 encodeURI 传入，这里按需求使用 decodeURI
  const token = rawToken ? decodeURI(rawToken) : ''

  // 没有 token 的情况下做兜底跳转
  if (!token) {
    const redirectPath =
      sourceType === 'exam' && jumpModuleId
        ? `/examPreflight?examId=${encodeURIComponent(jumpModuleId)}`
        : (sourceType === 'task' ? '/task' : '/')
    router.replace(`/login?redirect=${encodeURIComponent(encodeURIComponent(redirectPath))}`)
    return false
  }

  const authStore = useAuthStore()
  const usersStore = useUsersStore()
  authStore.setAccessToken(token)
  localStorage.setItem('sandsTalkToken', token)
  localStorage.setItem('sandsTalkTenantId', tenantId)

  if (collegeId) {
    usersStore.setCollegeId(collegeId)
  }

  try {
    await updateUserInfo()
  } catch (e) {
    console.warn('updateUserInfo failed after cn_driver_app auto-login:', e)
  }

  if (sourceType === 'exam' && jumpModuleId) {
    // 进入中转页，加载考试信息后自动跳转试卷
    router.replace({ path: '/examPreflight', query: { examId: jumpModuleId } })
  } else if (sourceType === 'task') {
    router.replace('/task')
  } else {
    router.replace('/')
  }

  return true
}

export const joinSandsTalkDriver = async () => {
  const request = { method: 'EnterSandyPage' }
  await callNative(request)
}

export const exitSandsTalkDriver = async () => {
  const request = { method: 'ExitSandyPage' }
  await callNative(request)
}


// 司机端 屏幕方向通道
export const driverOrientationChannel = (orientation: boolean) => {
  const request = { method: 'OrientationChannel', data: { orientation } }
  callNative(request)
}


// 司机下载H5链接  (文件下载)
export const driverDownloadH5Url = (url: string, name: string) => {
  console.log(`下载文件地址->url`, url)
  const request = { method: 'OpenFileChannel', data: { url, name } }
  callNative(request)
}

export const registerDriverPreviousH5 = () => {
  registerNative((result: any) => {
    console.log('registerNative', result)
    // 处理原生物理返回键
    const res = JSON.parse(result)
    if (res.method === 'BackChannel') {
      const currentRoute = router.currentRoute.value
      // 考试试卷页拦截返回并提示
      if (currentRoute?.path === '/paper') {
        showToast(i18n.global.t('exam_exit_warning'))
        return
      }
      const isCnDriverApp = router.currentRoute.value.meta?.isCnDriverApp
      if (isCnDriverApp) {
        exitSandsTalkDriver()
        router.go(-1)
      } else if (currentRoute?.path === '/task' && (window.history.length <= 1 || !document.referrer)) {
        exitSandsTalkDriver()
        router.go(-1)
      } else {
        router.go(-1)
      }
    }
  })

  // 定义返回方法供原生调用（虚拟按键及滑动手势返回）
  dsBridge.register('jtNativeCallH5Api', function () {
    const currentRoute = router.currentRoute.value
    // 考试试卷页拦截返回并提示
    if (currentRoute?.path === '/paper') {
      showToast(i18n.global.t('exam_exit_warning'))
      return 'success'
    }
    const isCnDriverApp = router.currentRoute.value.meta?.isCnDriverApp
    if (isCnDriverApp) {
      exitSandsTalkDriver()
      router.go(-1)
    } else if (currentRoute?.path === '/task' && (window.history.length <= 1 || !document.referrer)) {
      exitSandsTalkDriver()
      router.go(-1)
    } else {
      router.go(-1)
    }
    return 'success'
  })
}

